/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Updates_Not_SavedInputs */



/**
* | output |
* | --- |
* | "Modified data has not been saved" |
*
* @param {Updates_Not_SavedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const updates_not_saved = /** @type {((inputs?: Updates_Not_SavedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Updates_Not_SavedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Modified data has not been saved")
	return /** @type {LocalizedString} */ ("Les données modifiées n'ont pas été enregistrées")
});